/**
 * 智能客服 - 机器人过滤话术配置接口
 */
import { DEFAULT_PAGE_SIZE } from '@/constants/api';
import { apiDownload, apiGet, apiPost, apiPut, apiRequest } from '@/utils/request';
import { parsePaginatedResponse } from '@/utils/apiResponse';
import type {
  RobotFilterMessageConfigDetail,
  RobotFilterMessageConfigItem,
  RobotFilterMessageConfigPayload,
  RobotFilterMessageImportResult,
} from '@/types/robotFilterMessage';

/** 过滤话术配置：系统配置随列表返回一条，不提供增删改 */
export const robotFilterMessageConfigsApi = {
  list: (params: Record<string, unknown> = {}) =>
    apiGet('/robot-filter-message-configs', { page_size: DEFAULT_PAGE_SIZE, ...params }).then((d) =>
      parsePaginatedResponse<RobotFilterMessageConfigItem>(d),
    ),
  detail: (id: number) =>
    apiGet<RobotFilterMessageConfigDetail>(`/robot-filter-message-configs/${id}`),
  create: (data: RobotFilterMessageConfigPayload) => apiPost('/robot-filter-message-configs', data),
  update: (id: number, data: RobotFilterMessageConfigPayload) =>
    apiPut(`/robot-filter-message-configs/${id}`, data),
  updateEnabled: (id: number, status: number) =>
    apiPut(`/robot-filter-message-configs/${id}/enabled`, { status }),
  copy: (id: number) => apiPost(`/robot-filter-message-configs/${id}/copy`, {}),
  /** 下载导入模板（xlsx 文件流，文件名以响应头为准） */
  downloadTemplate: () =>
    apiDownload('/robot-filter-message-configs/download-template', {
      filename: 'AI-过滤话术导入.xlsx',
    }),
  /**
   * Excel 导入自定义配置：robot_id、version_type、file 必传，线上版本不允许导入。
   * 同名配置整份覆盖话术，不存在的新建；系统内置话术按名称跳过。
   */
  import: (data: FormData) =>
    apiRequest<RobotFilterMessageImportResult>('/robot-filter-message-configs/import', {
      method: 'POST',
      data,
    }),
  /**
   * 导出当前版本的全部话术（不受列表筛选影响），格式同导入模板，可直接回导；系统内置话术排最前。
   * apiDownload 走 fetch，不受 axios 超时限制。
   */
  export: (robotId: number, versionType: number) =>
    apiDownload('/robot-filter-message-configs/export', {
      params: { robot_id: robotId, version_type: versionType },
      filename: `过滤话术_机器人${robotId}.xlsx`,
    }),
};
